/*
 * Contact slider
 */
class RLM_ContactSlider {
    constructor (wrapper) {
        this.mainWrapper = jQuery(wrapper);
        
        if (!this.mainWrapper.find('.contact-slider-block').length) {
            return;
        }
        
        this.initState();        
        this.initEvents();
    }

    initState () {
        this.prevItem = 0;
        this.currentItem = 0;
        this.win = jQuery(window);
        this.wrapper = this.mainWrapper.find('.contact-slider-block');
        this.slideList = this.wrapper.find('.slider-list');
        this.slides = this.wrapper.find('.slider-item');
        this.dots = this.wrapper.find('.dot');
        this.count = parseInt(this.slideList.attr('data-count'), 10);
        this.blankSlide = false;
        this.interval = 3500;
        this.animationInProgress = false;
        this.swipeEffect = new Hammer(this.wrapper[0]);
    }

    initEvents () {
        let self = this;

        this.dots.on('click', function() {
            let index = parseInt(jQuery(this).attr('data-index'), 10);
            self.blankSlide = true;
            self.setItem(index);
        });

        setTimeout(() => {
            this.autoAnimate();
        }, this.interval);

        this.swipeEffect.on('swipe', ev => {
            if (ev.type === 'swipe' && (ev.direction === 1 || ev.direction === 2) && ev.deltaX < -100) {
                let itemIndex = this.currentItem;
                itemIndex++;

                if (itemIndex >= this.slides.length) {
                    itemIndex = 0;
                }
                
                this.dots.eq(itemIndex).trigger('click');
            }

            if (ev.type === 'swipe' && (ev.direction === 1 || ev.direction === 4) && ev.deltaX > 100) {
                let itemIndex = this.currentItem;
                itemIndex--;

                if (itemIndex < 0) {
                    itemIndex = this.slides.length - 1;
                }
                
                this.dots.eq(itemIndex).trigger('click');
            }
        });
    }

    autoAnimate () {
        if (this.blankSlide) {
            this.blankSlide = false;
        } else {
            let nextIndex = this.currentItem + 1;
            this.setItem(nextIndex);
        }

        setTimeout (() => {
            this.autoAnimate();
        }, this.interval); 
    }

    setItem (index) {
        if (this.animationInProgress) {
            return;
        }

        this.animationInProgress = true;
        this.prevItem = this.currentItem;
        this.currentItem = index;

        if (this.currentItem >= this.count) {
            this.currentItem = 0;
        }

        this.setActiveSlide();
        this.setActiveDot();
    }

    nextItem () {
        let nextIndex = this.currentItem;
        nextIndex++;
        this.setItem(nextIndex);
    }

    setActiveSlide () {
        this.slides.removeClass('is-active');
        this.slides.eq(this.currentItem).addClass('is-active');

        setTimeout(() => {
            this.slides.eq(this.prevItem).addClass('is-hidden');
        }, 300);

        setTimeout(() => {
            this.slides.eq(this.prevItem).removeClass('is-hidden');
            this.animationInProgress = false;
        }, 1000);
    }

    setActiveDot () {
        this.dots.removeClass('is-active');
        this.dots.eq(this.currentItem).addClass('is-active');
    }
}

new RLM_ContactSlider(document.body);